import React, { useEffect, useState } from 'react'
import styles from './PlanOutput.module.css'
import Logo from "../../assets/pdf-logo.png"
import Logout from '../../assets/logout.svg'
import downloadIcon from "../../assets/download-icon.png"
import DoughnutChart from '../../components/Chart/DoughnutChart'
import { prpHttpAPI } from '../../services/prpHttpAPI'
import { useNavigate, useLocation  } from 'react-router-dom'
import Modal from '../../components/Modal/Modal'
import { jwtDecode } from 'jwt-decode'
const PlanOutput = () => {
    const location = useLocation();
    const previousPage = location.state?.from || "unknown";
     const [rows, setRows] = useState([]);
    const [userData, setUserData] = useState(null);
    const [modifiedPlanId, setmodifiedPlanId] = useState(null);
    const [loading, setLoading]=useState(false);
    const [downloadFlag, setDownloadFlag] = useState(false);
    const [showModal, setShowModal] = useState(false)
    const[url,setUrl]=useState(null);
    const plan_id  = localStorage.getItem("plan_id");
    const versions = localStorage.getItem('versions');
    console.log("versions", versions);
    const [selectedVersion, setSelectedVersion] = useState(Number(versions));
    const data = {
        plan_id:plan_id
    }

  const navigate = useNavigate()
  // token authentication 
  const checkToken = (e) => {

    const localtoken = localStorage.getItem("ssotoken");
    // const location = useLocation();
    // const queryParams = new URLSearchParams(location.search);
    // const ssotoken = queryParams.get('ssotoken');
    if (localtoken) {
      console.log('User logged in');
    }
    else {
      console.log('token not found');
      // Redirect to a different URL
      window.location.href = `${import.meta.env.VITE_SSO_URL}?clientId=${import.meta.env.VITE_SSO_CLIENT_ID}`;

      //  navigate('');
    }
  }
  useEffect(()=>{
    checkToken();
  },[]) 
    const handleLogout = () => {
    // Clear session storage (or localStorage if you want)
    localStorage.clear();
    navigate('/?action=logout'); // Adjust the path to your login page
  };
  ////////////CASH FLOW//////////////
const cashFlow = (userData) => {
  
    const currentAge = userData.clientsDetails.age;
    const retirementAge = userData.clientsDetails.year_of_retirement;
    const lifeExpectancy = userData.clientsDetails.life_expectancy;
  
    const totalInvestments = userData.planDetails.totalInvestments;
    const preRetRor = userData.investmentDetails.pre_ret_ror;
    const postRetRor = userData.investmentDetails.post_ret_ror;
    const totalContribution = userData.planDetails.TotalContributions;
    const additionalSaving = userData.planDetails.shortageRYType == 'surplus' ? 0 : userData.planDetails.additionalSavRqd.monthly;
    const retirementExpenseRY = userData.planDetails.retirementExpanceRY;
    const inflationRate = userData.clientsDetails.inflation_rate;
  
    const annualSavings = totalContribution * 12;
    const additionalSavings = additionalSaving * 12;
  
    let previousYearEndValue = totalInvestments;
    let previousWithdrawal = 0;
    let newArr = [];
  
    for (let age = currentAge; age <= lifeExpectancy; age++) {
      // Invested value
      const investedValue = age === currentAge ? totalInvestments : previousYearEndValue;
  
      // Annual return
      const annualReturn = (investedValue * ( (age==retirementAge || age>retirementAge) ? postRetRor : preRetRor))/100;
  
      // Withdrawal logic
      let withdrawal = 0;
      if (age >=( retirementAge+1)) {
        withdrawal = age === (retirementAge+1)
          ? retirementExpenseRY * (1 + inflationRate/100)
          : previousWithdrawal * (1 + inflationRate/100);
      }else if(age==retirementAge){
        withdrawal = retirementExpenseRY
      }
  
      // Year end value
      const yearEndValue = investedValue + annualReturn +  ((age==retirementAge || age> retirementAge) ? 0 : annualSavings) + ((age==retirementAge || age> retirementAge) ? 0 : additionalSavings) - withdrawal;
  
      // Save values
      newArr.push([
        age,
        investedValue,
        annualReturn,
        ((age==retirementAge || age> retirementAge) ? 0 : annualSavings),
        ((age==retirementAge || age> retirementAge) ? 0 : additionalSavings),
        withdrawal,
       (yearEndValue<0? 0 : yearEndValue)
      ]);
  
      // Prepare for next loop
      previousWithdrawal = withdrawal;
      previousYearEndValue = yearEndValue;
      setRows(newArr)
    }
  
    console.log("Final rows:", rows, newArr);
    return rows;
  };

  //pdfURL
    const getPdfURL = async () => {
      let returnObj = null;
      try {
        setShowModal(true);
        const result = await prpHttpAPI(data, 'get-pdf/pdf', null, "POST",null)
        if (result.success) {
          returnObj = result;
  
        }
      } catch (error) {
        console.log("There is some error after api fetch", error.message);
      }
  
      return returnObj
  
    }
//pdf download
const donwloadPDF = async (url) => {
    //console.log('download pdf function called')
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank"
    link.download = `${plan_id}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    //console.log("pdfUrl", url);

  }
    
    useEffect(() => {
        const getPdfDetails = async()=>{
            try{
                setLoading(true)
                const result = await prpHttpAPI(data, 'get-pdf/details',null, "POST",null)
                console.log("result is: ",result);
                let planId = result.clientsDetails?.plan_id || "";
                planId = planId.split('_')[0];  // or planId.replace(/_.*$/, '');
                
                if(result?.success){
                 localStorage.setItem('userData', JSON.stringify(result.clientsDetails))
                 localStorage.setItem('clientInvestmentData', JSON.stringify(result.investmentDetails))
                 setUserData(result)
                 setmodifiedPlanId(planId)
                 cashFlow(result)
            }
            }catch (error) {
                console.log("There is some error after api fetch", error.message);
              }finally{
                setLoading(false)
              }
        }
      getPdfDetails()
    }, [data.plan_id])
//version select
// Handle selection change
const handleSelectChange = (event) => {
  const selectedValue = event.target.value;
  let updatedPlanId="";
  if(selectedValue==1){
      updatedPlanId = modifiedPlanId
  }else{
   updatedPlanId = `${modifiedPlanId}_${selectedValue}`;
}

  setSelectedVersion(selectedValue);
  localStorage.setItem("plan_id", updatedPlanId);
};
//  date fomatting 
const formatDate=(dateString)=>{
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // en-GB gives dd/mm/yyyy format
}
// nullOrNaN check
const checkForNullOrNaN=(value)=> {
    return (value === null || value === 'NaN' || isNaN(value)) ? 0 : value;
  }
// make values to crores and lakh 

function formatNumberToIndianUnits(num) {
    let flag = false;
    if (num<0) flag=true;
    num = Math.abs(num)
    if (num >= 1e9) {
        return (flag? -(num / Math.pow(10, Math.floor(Math.log10(num)))).toFixed(2) + " × 10^" + Math.floor(Math.log10(num)):(num / Math.pow(10, Math.floor(Math.log10(num)))).toFixed(2) + " × 10^" + Math.floor(Math.log10(num)));
    }
    if (num >= 1e7) {
        return (flag? -(num / 1e7).toFixed(2) + " Cr" : (num / 1e7).toFixed(2) + " Cr");    } 
    else if (num >= 1e5) {
        return (flag? -(num / 1e5).toFixed(2) + " Lakh" : (num / 1e5).toFixed(2) + " Lakh");
    } 
    else {
        return (flag? -Intl.NumberFormat('en-IN').format(num.toFixed(2)):Intl.NumberFormat('en-IN').format(num.toFixed(2))); // Formats number with commas for Indian numbering
    }
}
//finalBtn
const handleDownloadPDF=async()=>{
    setLoading(true)
        let pdfResult = await getPdfURL();
        setUrl(pdfResult?.url)
        console.log("get-pdf/pdf Response:  ", pdfResult);

        if (!pdfResult?.success) {
          console.log('pdf url is empty');
          return;
        }
        

  //////////////
            let firstDownload = downloadFlag;
            console.log('first download', firstDownload);
          setLoading(false);
          donwloadPDF(pdfResult.url);
          setDownloadFlag(true);
          if(previousPage=='clientInvestment' && firstDownload==false){
            //////////////
                       // Send email notification with download link
//             try {
//   const localtoken = localStorage.getItem("ssotoken");
//   const rm_name  = localStorage.getItem('rm_name');
//   const plan_ID = localStorage.getItem('plan_id');
//   const rm_email = localStorage.getItem('rm_email');
//   console.log("rm_email is", rm_email);
//   const emailData = {
//     plan_id : plan_ID,
//      rm_name:rm_name,
//      rm_email:rm_email
//   };

//   const result = await prpHttpAPI(emailData, 'get-pdf/send-email', null, "POST", null);
//   if (result.success) {
//     console.log("Email sent successfully.");
//   }
// } catch (error) {
//   console.error("Error sending email:", error);
// }

            /////////////
            const localtoken = localStorage.getItem("ssotoken");
            const result = await prpHttpAPI(data, 'status', localtoken, "POST",null)
            
            if(result){
                console.log("result in status api", result);
            }
          }
         
        

}

//new plan
const handleEdit=async()=>{
      if(JSON.parse(localStorage.getItem('planCompletedFlag'))==false){
        localStorage.setItem('userData', localStorage.getItem('editableData'));
        localStorage.removeItem('clientInvestmentData');
      };
      console.log('completed flag is', localStorage.getItem('planCompletedFlag'));
      navigate('/client-details?path=edit');
  }


  return (
    <>
   
{ userData?   <div className={styles.main}>
        {/* {loading && <div>LOADING</div>} */}
       {/* <nav className={`navbar bg-white p-3 fixed-top flex justify-content-end ${styles.pdfNav}`}>
       {!downloadFlag ?
       <div>
        <button onClick={handleBack} className="btn btn-outline-success me-4" type="button">Back</button>
        <button onClick={handleFinalPlan} className="btn btn-outline-danger" type="button">Finalise Plan</button>
        </div>
       : 
       <div>
       <button onClick={handlePlan} className="btn btn-outline-success me-4" type="button">Prepare a New Plan</button>
       <button onClick={handleDownloadPDF} className="btn btn-outline-danger" type="button">Download Pdf <span className='ps-2'> <img src={downloadIcon} alt="download-icon" /> </span></button>

       </div>
          }
        </nav> */}

    
        <div className='pdf-page-one'>

        {/* Header */}
        <div className={styles.header}>
        <header>
        <a href="/search">
            <img className={styles.headImg}  src={Logo} alt="BajajLogo" />
         </a>   
             {/* nav  */}
       <nav className={`navbar bg-white p-3 flex justify-content-end ${styles.pdfNav}`}>
      {/* {previousPage=="search" && 
       <div>
       <select className="form-select" onChange={handleSelectChange} value={selectedVersion}>
      <option value="" disabled>
        Select Version
      </option>
      {[...Array(Number(versions))].map((_, index) => {
        const versionNumber = index + 1;
        return (
          <option key={versionNumber} value={versionNumber}>
            Version {versionNumber}
          </option>
        );
      })}
    </select>
       <button onClick={handleDownloadPDF} className="btn btn-outline-danger m-2" type="button"><span className='pe-1'><img src={downloadIcon} alt="download-icon" /> </span> Download</button>
       <button  onClick={handleEdit} className={`btn btn-outline-danger m-2 ${styles.disableEdit}`} type="button" disabled={selectedVersion!=Number(versions)}>Edit</button>
       </div>
      } */}
      
       {/* prepare plan nav */}
      {previousPage =="clientInvestment" ?
      <div>
        {downloadFlag &&  <select className="form-select" onChange={handleSelectChange} value={selectedVersion}>
      <option value="" disabled>
        Select Version
      </option>
      {[...Array(Number(versions))].map((_, index) => {
        const versionNumber = index + 1;
        return (
          <option key={versionNumber} value={versionNumber}>
            Version {versionNumber}
          </option>
        );
      })}
    </select>}
       <button onClick={handleDownloadPDF} className="text-nowrap btn btn-outline-danger m-2" type="button">{downloadFlag ? 'Download' : 'Confirm & Download'}</button>
       {(localStorage.getItem('bCode') == userData?.clientsDetails?.rm_code) && <button onClick={handleEdit} className="btn btn-outline-danger m-2" type="button" disabled={selectedVersion!=Number(versions)}>Edit</button>}
             <button onClick={handleLogout} className="btn btn-outline-danger m-2" type="button"><span className='pe-1'><img src={Logout} alt="logout-icon" /> </span> Logout</button>
       </div>
       :
       <div>
       <select className="form-select" onChange={handleSelectChange} value={selectedVersion}>
      <option value="" disabled>
        Select Version
      </option>
      {[...Array(Number(versions))].map((_, index) => {
        const versionNumber = index + 1;
        return (
          <option key={versionNumber} value={versionNumber}>
            Version {versionNumber}
          </option>
        );
      })}
    </select>
       <button onClick={handleDownloadPDF} className="btn btn-outline-danger m-2" type="button"><span className='pe-1'><img src={downloadIcon} alt="download-icon" /> </span> Download</button>
       {(localStorage.getItem('bCode') == userData?.clientsDetails?.rm_code) && <button  onClick={handleEdit} className={`btn btn-outline-danger m-2 ${styles.disableEdit}`} type="button" disabled={selectedVersion!=Number(versions)}>Edit</button>}
                    <button onClick={handleLogout} className="btn btn-outline-danger m-2" type="button"><span className='pe-1'><img className={styles.logoutImg} src={Logout} alt="logout-icon" /> </span> Logout</button>
       </div>
       
       }
       </nav>
        </header>
        <div className={styles.headText}>
            <p>PRE-RETIREMENT PLAN</p>
        </div>
        </div>
         {/* Client name */}
         <div className={styles.clientDiv}>
            <div className={styles.clientName}>
            <span>Dear</span><span><b> {userData?.clientsDetails?.client_name},</b></span>
            </div>
            <div className={styles.clientChild}>
                <div className={styles.clientInfoChild}>
                    <p>Your Plan ID</p>
                    <p><b>{userData.clientsDetails.plan_id}</b></p>
                </div>
                <div className={styles.clientInfoChild}>
                    <p>RM Name & Location</p>
                    <p><b>  {userData.clientsDetails.spoc_rm_name ? userData.clientsDetails.spoc_rm_name:  (userData.clientsDetails?.rm_details ? (JSON.parse(userData.clientsDetails.rm_details).name) : "No RM Name")} / { userData.clientsDetails.spoc_rm_branch ? userData.clientsDetails.spoc_rm_branch : (JSON.parse(localStorage.getItem('rmInfo'))?.BRANCH_NAME || 'Retirement Team')}</b></p>
                </div>
                <div className={styles.clientInfoChild}>
                    <p>Prepared On</p>
                    <p><b>{formatDate(userData?.clientsDetails?.created_at)}</b></p>
                </div>
            </div>
         </div>
         {/* Client Info */}
         <div className={styles.clientInfo}>
            <div className={styles.infoHead}><span><b>Client Information</b></span></div>
            <div className={styles.infoMainDiv}>
            <div className={styles.infoDiv}>
                <div className={styles.infoChild}>
                    <p>Current Age</p>
                    <p><b>{checkForNullOrNaN(userData.clientsDetails.age)} Y</b></p>
                </div>
                <div className={styles.infoChild}>
                    <p>Retirement Age</p>
                    <p><b>{checkForNullOrNaN(userData.clientsDetails.year_of_retirement)} Y</b></p>
                </div>
                <div className={styles.infoChild}>
                    <p>Life Expectancy</p>
                    <p><b>{checkForNullOrNaN(userData.clientsDetails.life_expectancy)} Y</b></p>
                </div>
                <div className={styles.infoChild}>
                <p>Inflation Rate</p>
                <p><b>{checkForNullOrNaN(userData.clientsDetails.inflation_rate)} %</b></p>
                </div>
            </div>
            
           
             <div className={styles.infoDiv}>
                { userData.clientsDetails?.annual_income ?
                 <div className={styles.infoChild}>
                 <p>Annual Income</p>
                 <p><b> ₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.clientsDetails.annual_income))}</b></p>
             </div>
            :
            <div className={styles.infoChild}>
            </div>
            }
            
                <div className={styles.infoChild}>
                    <p className='text-center'>Monthly Expenses</p>
                    <div className={styles.childDiv}>
                    <p><b>₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.clientsDetails.monthly_expenses))} </b><br/> <span>If Retire Today</span></p>
                    <p><b>₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementExpanceRYMonthly))} </b><br/> <span>At Retirement</span></p>
                    </div>
                </div>
                <div className={styles.infoChild}></div>
                <div className={styles.infoChild}>
                    <p className='text-center'>Rate of Return p.a expected</p>
                    <div className={styles.childDiv}>
                    <p><b>{checkForNullOrNaN(userData.investmentDetails.pre_ret_ror)} % </b><br/> <span>Before Retirement</span></p>
                    <p><b>{checkForNullOrNaN(userData.investmentDetails.post_ret_ror)} % </b><br/> <span>After Retirement</span></p>
                    </div>
                </div>
            </div>
            </div>
         </div>
         {/* Investment Table */}
         <div className={styles.investmentDiv}>
            <table className={styles.investmentTable}>
                <thead>
                <tr>
                    <th>Investment</th>
                    <th style={{textAlign:"right"}}>Current Holding</th>
                    <th style={{textAlign:"right"}}>Monthly Contribution</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>EPF</td>
                     <td style={{textAlign:"right"}} >₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.epf_holding))}</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.epf_monthly))}</td>
                </tr>
                <tr>
                    <td>PPF</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.ppf_holding))}</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.ppf_monthly))}</td>
                </tr>
                <tr>
                    <td>NPS</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.nps_holding))}</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.nps_monthly))}</td>
                </tr>
                <tr>
                    <td>Other Retirement Investments</td>
                    <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.other_retirement_investment_holding))}</td>
                    <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.other_retirement_investment_monthly))}</td>
                </tr>
                <tr>
                    <td>Mutual Funds</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.mf_holding))}</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.mf_monthly))}</td>
                </tr>
                <tr>
                    <td>Stocks</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.stocks_holding))}</td>
                     <td style={{textAlign:"right"}}>-</td>
                </tr>
                <tr>
                    <td>Bonds</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.bonds_holding))}</td>
                     <td style={{textAlign:"right"}}>-</td>
                </tr>
                <tr>
                    <td>Fixed Deposits & Recurring Deposits</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.fdrd_holding))}</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.fdrd_monthly))}</td>
                </tr>
                <tr>
                    <td>Other Non-Retirement Investments</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.other_non_retirement_investment_holding))}</td>
                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.other_non_retirement_investment_monthly))}</td>
                </tr>
                <tr>
                    <td><b>Total :</b></td>
                     <td style={{textAlign:"right"}} >₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.epf_holding)+checkForNullOrNaN(userData.investmentDetails.ppf_holding)+checkForNullOrNaN(userData.investmentDetails.nps_holding)+checkForNullOrNaN(userData.investmentDetails.other_retirement_investment_holding)+checkForNullOrNaN(userData.investmentDetails.mf_holding)+checkForNullOrNaN(userData.investmentDetails.stocks_holding)+checkForNullOrNaN(userData.investmentDetails.bonds_holding)+checkForNullOrNaN(userData.investmentDetails.fdrd_holding)+checkForNullOrNaN(userData.investmentDetails.other_non_retirement_investment_holding))}</td>

                     <td style={{textAlign:"right"}}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.investmentDetails.epf_monthly)+checkForNullOrNaN(userData.investmentDetails.ppf_monthly)+checkForNullOrNaN(userData.investmentDetails.nps_monthly)+checkForNullOrNaN(userData.investmentDetails.other_retirement_investment_monthly)+checkForNullOrNaN(userData.investmentDetails.mf_monthly)+checkForNullOrNaN(userData.investmentDetails.fdrd_monthly)+checkForNullOrNaN(userData.investmentDetails.other_non_retirement_investment_monthly))}</td>
                </tr>
                </tbody>
            </table>

         </div>
         </div>
         {/* Analysis */}
         
         <div className={`${styles.analysis} pdf-page-two`} >
            <div className={styles.analysisHead}>
                <span><b>Analysis</b></span>
            </div>
            <p>You have {checkForNullOrNaN(userData.planDetails.YearsUnitilRetirement)} years to retire and expect to spend {checkForNullOrNaN(userData.planDetails.retirementYears)} years in retirement</p>
            <div className={styles.timeline}>
                {/* case equal to 50% */}
                { checkForNullOrNaN(userData.planDetails.goalAchievement.percentage)==50 && 
                <div className={styles.mainBar}>
                    <div className={styles.leftBar}></div>
                    <div className={styles.rightBar}></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div>
                    {new Date().getFullYear()} <br/>Present
                    </div>
                    <div>
                    Goal Achieved <span>{checkForNullOrNaN(userData.planDetails.goalAchievement.percentage).toFixed(2)}% </span>
                     (₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.goalAchievement.value))})
                    </div>
                    <div>
                    {new Date().getFullYear() - userData.clientsDetails.age  + checkForNullOrNaN(userData.clientsDetails.year_of_retirement)}<br/>Retirement Year
                    </div>
                    <div>
                    ₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}<br/> Target Corpus
                    </div>
                </div>
                }
                 
                 {/* case less than 50% */}
                { checkForNullOrNaN(userData.planDetails.goalAchievement.percentage) < 50 &&   <div className={styles.mainBarL}>
                    <div className={styles.leftBarL}></div>
                    <div className={styles.rightBarL}></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div>
                    {new Date().getFullYear()} <br/>Present
                    </div>
                    <div>
                    Goal Achieved <span> {checkForNullOrNaN(userData.planDetails.goalAchievement.percentage).toFixed(2)}%</span>
                     (₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.goalAchievement.value))})
                    </div>
                    <div>
                    {new Date().getFullYear() - userData.clientsDetails.age  + checkForNullOrNaN(userData.clientsDetails.year_of_retirement)}<br/>Retirement Year
                    </div>
                    <div>
                    ₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}<br/> Target Corpus
                    </div>
                </div>
                }
                
               {/* Case greater than 50% */}
               {checkForNullOrNaN(userData.planDetails.goalAchievement.percentage) > 50 && checkForNullOrNaN(userData.planDetails.goalAchievement.percentage) < 100 && 
                 <div className={styles.mainBarG}>
                    <div className={styles.leftBarG}></div>
                    <div className={styles.rightBarG}></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div>
                    {new Date().getFullYear()} <br/>Present
                    </div>
                    <div>
                    Goal Achieved <span>{checkForNullOrNaN(userData.planDetails.goalAchievement.percentage).toFixed(2)}% </span>
                     (₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.goalAchievement.value))})
                    </div>
                    <div>
                    {new Date().getFullYear() - userData.clientsDetails.age  + checkForNullOrNaN(userData.clientsDetails.year_of_retirement)}<br/>Retirement Year
                    </div>
                    <div>
                    ₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}<br/> Target Corpus
                    </div>
                </div> }
                  
                 {/* Case greater tha equal to 100% */}
                 {checkForNullOrNaN(userData.planDetails.goalAchievement.percentage) >= 100 &&  
                  <div className={styles.mainBarF}>
                    <div></div>
                    <div></div>
                    
                    <div>
                    {new Date().getFullYear()} <br/>Present
                    </div>
                    <div>
                    Goal Achieved <span>{checkForNullOrNaN(userData.planDetails.goalAchievement.percentage).toFixed(2)}% </span>
                     (₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.goalAchievement.value))})
                    </div>
                    <div>
                    {new Date().getFullYear() - userData.clientsDetails.age  + checkForNullOrNaN(userData.clientsDetails.year_of_retirement)}<br/>Retirement Year
                    </div>
                </div>
                 }
                
            </div>
            <p>Your Total Investments are ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.totalInvestments))} as on today, out of which ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.RetirementInvestments))} are in Retirement focused instruments and ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments))} are in Non Retirement Instruments.
            </p>
            <p>You are contributing ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.TotalContributions))} every month. Out of this ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.RetirementContributions))} is towards retirement focused investments and ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementContributions))} is towards other investments.</p>
            <p>You will require a corpus of ₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))} at the time of retirement to have enough money to live through your retirement.</p>
            <br></br>
           {/* doughnutDiv */}
           <div className={styles.doughnutDiv}> 
            <div className={styles.doughnutTop}>
            <div className={styles.doughnut}><DoughnutChart corpus = {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))} 
             data={[checkForNullOrNaN(userData.planDetails.graph.investment.percentage).toFixed(2),
                checkForNullOrNaN(userData.planDetails.graph.retirementContributions.percentage).toFixed(2),
                checkForNullOrNaN(userData.planDetails.graph.shortage.percentage).toFixed(2)
              ]}
            /></div>
            <div className={styles.doughnutLabel}>
                <ul>
                    <li><span>Total Investment Value at Retirement</span> <span>{`( ${ checkForNullOrNaN(userData.planDetails.graph.investment.percentage).toFixed(2)}% )`}</span></li>
                    <li><span>Total Monthly Contribution Value at Retirement</span> <span>{`( ${checkForNullOrNaN(userData.planDetails.graph.retirementContributions.percentage).toFixed(2)}% )`}</span></li>
                    <li><span>{userData.planDetails.shortageRYType == 'surplus'?'Surplus' : 'Shortage'}</span> <span>{`( ${checkForNullOrNaN(userData.planDetails.graph.shortage.percentage).toFixed(2)}% )`}</span></li>
                </ul>
            </div>
            <div className={styles.doughnutValue}>
                <ul>
                    <li>₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.graph.investment.investmentAmount))} </li>
                    <li>₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.graph.retirementContributions.retirementContributionsAmount))} </li>
                    <li>₹ {formatNumberToIndianUnits(Math.round(checkForNullOrNaN(userData.planDetails.graph.shortage.shortageAmount)))} </li>
                </ul>
            </div>
            </div>
            
            <div className={styles.doughnutBottom}>
            {userData.planDetails.shortageRYType == 'surplus' ? 'You have reached the stage of financial freedom, However, we suggest you rebalance your investments and saving plan.' : `To cover shortage start saving ₹ ${Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.additionalSavRqd.monthly))}/m or lumpsum ₹ ${Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.additionalLumsumRqd.value))} `}  
            </div>
            </div>
         </div>
         {/* Action Plan */}
         <div className={`${styles.actionPlan} pdf-page-three`}>
            <p className={styles.apHead}>
            <span><b>Action Plan</b></span>
            </p>
            {/* CASE 1 When -- RetirementInvestment>0; Non-Retirement Investments>0 sortage == 'sortage' */}
            {
            checkForNullOrNaN(userData.planDetails.RetirementInvestments) > 0 &&
            checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) > 0 &&
            checkForNullOrNaN(userData.planDetails.shortageRYType === 'shortage') && 
                (
                    <div>Since you have {(checkForNullOrNaN(userData.planDetails.YearsUnitilRetirement))} years to reach your retirement, have a shortage to meet your Retirement Corpus so you should consider rebalancing your Non-Retirement Investments as given below:
                    <ol>
                        <li> You are currently saving ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementContributions))} every month towards Non-Retirement Investments.</li>
                        <li> You need to save ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.additionalSavRqd.monthly))} additionally every month.</li>
                        <li> Totally you will have to save ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementContributions) + checkForNullOrNaN(userData.planDetails.additionalSavRqd.monthly))} every month towards Non-Retirement Investments.</li>
                    </ol>
                    You may rework on your savings plan as given below -</div>
                )
                }

     {/* CASE 2  When -- RetirementInvestment>0; Non-Retirement Investments>0 sortage == 'surplus' */}
           {
            checkForNullOrNaN(userData.planDetails.RetirementInvestments) > 0 &&
            checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) > 0 &&
            checkForNullOrNaN(userData.planDetails.shortageRYType === 'surplus') && 
                (
                    <div>Since you have {(checkForNullOrNaN(userData.planDetails.YearsUnitilRetirement))} years to reach your retirement, we suggest you to consider rebalancing your Non-Retirement Investments for optimal returns, as given below:
                    <ol>
                        <li>  You are currently saving ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementContributions))} every month towards Non-Retirement Investments which surpasses your retirement needs.</li>
                        <li> In accordance with your years until retirement we suggest you to rebalance your portfolio as per the optimal allocation presented below -</li>
                    </ol>
                    </div>
                )
                }

          {/* CASE 3 When -- RetirementInvestment>=0; Non-Retirement Investments=0 sortage == 'shortage' */}
           {
            checkForNullOrNaN(userData.planDetails.RetirementInvestments) >= 0 &&
            checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) == 0 &&
            checkForNullOrNaN(userData.planDetails.shortageRYType === 'shortage') && 
                (
                    <div>Since you have {(checkForNullOrNaN(userData.planDetails.YearsUnitilRetirement))} years to reach your retirement, you should consider saving ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.additionalSavRqd.monthly))} and invest in the following manner to meet your Retirement Planning Goal:
                      <ol>
                      <li> You are currently saving ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementContributions))} every month towards Non-Retirement Investments.</li>
                      <li> You need to save ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.additionalSavRqd.monthly))} additionally every month.</li>
                      <li> Totally you will have to save ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementContributions) + checkForNullOrNaN(userData.planDetails.additionalSavRqd.monthly))} every month towards Non-Retirement Investments.</li>
                  </ol>
                   You may rework on your savings plan as given below -</div>
                )
                }

                  {/* CASE 4 When -- RetirementInvestment>0; Non-Retirement Investments=0 sortage == 'surplus' */}
           {
            checkForNullOrNaN(userData.planDetails.RetirementInvestments) >= 0 &&
            checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) == 0 &&
            checkForNullOrNaN(userData.planDetails.shortageRYType === 'surplus') && 
                (
                    <div>Since your retirement investments will be sufficient to provide you a regular income, hence you should continue with your existing portfolio.
                    </div>
                )
                }

                   {/* CASE 5 When -- RetirementInvestment = 0; Non-Retirement Investments>0 sortage == 'sortage' */}
            {
            checkForNullOrNaN(userData.planDetails.RetirementInvestments == 0) &&
            checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) > 0 &&
            checkForNullOrNaN(userData.planDetails.shortageRYType === 'shortage') && 
                (
                    <div>Since you have {(checkForNullOrNaN(userData.planDetails.YearsUnitilRetirement))} years to reach your retirement, have a shortage to meet your Retirement Corpus so you should consider rebalancing your Non-Retirement Investments as given below:
                    <ol>
                        <li> You are currently saving ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementContributions))} every month towards Non-Retirement Investments.</li>
                        <li> You need to save ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.additionalSavRqd.monthly))} additionally every month.</li>
                        <li> Totally you will have to save ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementContributions) + checkForNullOrNaN(userData.planDetails.additionalSavRqd.monthly))} every month towards Non-Retirement Investments.</li>
                    </ol>
                    You may rework on your savings plan as given below -</div>
                )}

                 {/* CASE 6 When -- RetirementInvestment = 0; Non-Retirement Investments>0 sortage == 'surplus' */}
            {
           checkForNullOrNaN( userData.planDetails.RetirementInvestments) == 0 &&
           checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) > 0 &&
           checkForNullOrNaN(userData.planDetails.shortageRYType === 'surplus') && 
                (
                    <div>Since you have {(checkForNullOrNaN(userData.planDetails.YearsUnitilRetirement))} years to reach your retirement, we suggest you to consider rebalancing your Non-Retirement Investments for optimal returns, as given below:
                    <ol>
                        <li>  You are currently saving ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementContributions))} every month towards Non-Retirement Investments which surpasses your retirement needs.</li>
                        <li> In accordance with your years until retirement we suggest you to rebalance your portfolio as per the optimal allocation presented below -</li>
                    </ol>
                    </div>
                )}
           
            
           
                        {/* Balancing Table for surplus*/}
                        { !((checkForNullOrNaN(userData.planDetails.RetirementInvestments) > 0 &&
                checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) == 0 &&
                userData.planDetails.shortageRYType === 'surplus')|| userData.planDetails.shortageRYType === 'shortage') && (
                    <>
    <table className={styles.actionPlanTable}>
    <thead>
        <tr>
            <th>Fund Type</th>
            <th style={{ textAlign: "right" }}>Allocation</th>
            <th style={{ textAlign: "right" }}>Investment Amount</th>
            <th style={{ textAlign: "right" }}>SIP Amount</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>Equity Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.equityFunds.allocation)} %
            </td>
            <td style={{ textAlign: "right" }}>
                ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.equityFunds.investmentA))}
            </td>
            {(
                <td style={{ textAlign: "right" }}>
                    ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.equityFunds.sipAmount))}
                </td>
            )}
        </tr>
        <tr>
            <td>Balanced Advantage Hybrid Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.balancedAdvantageHF.allocation)} %
            </td>
            <td style={{ textAlign: "right" }}>
                ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.balancedAdvantageHF.investmentA))}
            </td>
            {(
                <td style={{ textAlign: "right" }}>
                    ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.balancedAdvantageHF.sipAmount))}
                </td>
            )}
        </tr>
        <tr>
            <td>Conservative Hybrid Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.ConservativeHF.allocation)} %
            </td>
            <td style={{ textAlign: "right" }}>
                ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.ConservativeHF.investmentA))}
            </td>
            {(
                <td style={{ textAlign: "right" }}>
                    ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.ConservativeHF.sipAmount))}
                </td>
            )}
        </tr>
        <tr>
            <td>Medium Term Debt Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.MTDebtAllocation.allocation)} %
            </td>
            <td style={{ textAlign: "right" }}>
                ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.MTDebtAllocation.investmentA))}
            </td>
            { (
                <td style={{ textAlign: "right" }}>
                    ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.MTDebtAllocation.sipAmount))}
                </td>
            )}
        </tr>
        <tr>
            <td>Short Term Debt Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.STDebtAllocation.allocation)} %
            </td>
            <td style={{ textAlign: "right" }}>
                ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.STDebtAllocation.investmentA))}
            </td>
            { (
                <td style={{ textAlign: "right" }}>
                    ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.STDebtAllocation.sipAmount))}
                </td>
            )}
        </tr>
        <tr>
            <td><b>Total :</b></td>
            <td style={{ textAlign: "right" }}>100 %</td>
            <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.equityFunds.investmentA) + checkForNullOrNaN(userData.planDetails.balancedAdvantageHF.investmentA)+checkForNullOrNaN(userData.planDetails.ConservativeHF.investmentA)+checkForNullOrNaN(userData.planDetails.MTDebtAllocation.investmentA)+checkForNullOrNaN(userData.planDetails.STDebtAllocation.investmentA))}</td>
            { (
                <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.equityFunds.sipAmount)+checkForNullOrNaN(userData.planDetails.balancedAdvantageHF.sipAmount)+checkForNullOrNaN(userData.planDetails.ConservativeHF.sipAmount)+checkForNullOrNaN(userData.planDetails.MTDebtAllocation.sipAmount)+checkForNullOrNaN(userData.planDetails.STDebtAllocation.sipAmount))}</td>
            )}
        </tr>
    </tbody>
            </table> 
            {/* <div>
            Or otherwise          
                    <div className='ps-4'>
                        <p> You currently have ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments))} towards Non-Retirement Investments.</p>
                        <p>You need to invest Lumpsum additionally ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.additionalLumsumRqd.value))} towards Non-Retirement Investments</p>
                        <p>Totally you will have to Invest ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) + checkForNullOrNaN(userData.planDetails.additionalLumsumRqd.value))}  towards Non-Retirement Investments</p>
                    </div>
                    You may rework on your non retirement investments as given below-
                  </div>     */}
        </>
        )}

            {/* Balancing Table for shortage*/}

           { !((checkForNullOrNaN(userData.planDetails.RetirementInvestments) > 0 &&
                checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) == 0 &&
                userData.planDetails.shortageRYType === 'surplus')|| userData.planDetails.shortageRYType === 'surplus') && (
                    <>
    <table className={styles.actionPlanTable}>
    <thead>
        <tr>
            <th>Fund Type</th>
            <th style={{ textAlign: "right" }}>Allocation</th>
            <th style={{ textAlign: "right" }}>SIP Amount</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>Equity Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.equityFunds.allocation)} %
            </td>
            {(
                <td style={{ textAlign: "right" }}>
                    ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.equityFunds.sipAmount))}
                </td>
            )}
        </tr>
        <tr>
            <td>Balanced Advantage Hybrid Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.balancedAdvantageHF.allocation)} %
            </td>
            {(
                <td style={{ textAlign: "right" }}>
                    ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.balancedAdvantageHF.sipAmount))}
                </td>
            )}
        </tr>
        <tr>
            <td>Conservative Hybrid Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.ConservativeHF.allocation)} %
            </td>
            {(
                <td style={{ textAlign: "right" }}>
                    ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.ConservativeHF.sipAmount))}
                </td>
            )}
        </tr>
        <tr>
            <td>Medium Term Debt Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.MTDebtAllocation.allocation)} %
            </td>
            { (
                <td style={{ textAlign: "right" }}>
                    ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.MTDebtAllocation.sipAmount))}
                </td>
            )}
        </tr>
        <tr>
            <td>Short Term Debt Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.STDebtAllocation.allocation)} %
            </td>
            { (
                <td style={{ textAlign: "right" }}>
                    ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.STDebtAllocation.sipAmount))}
                </td>
            )}
        </tr>
        <tr>
            <td><b>Total :</b></td>
            <td style={{ textAlign: "right" }}>100 %</td>
            { (
                <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.equityFunds.sipAmount)+checkForNullOrNaN(userData.planDetails.balancedAdvantageHF.sipAmount)+checkForNullOrNaN(userData.planDetails.ConservativeHF.sipAmount)+checkForNullOrNaN(userData.planDetails.MTDebtAllocation.sipAmount)+checkForNullOrNaN(userData.planDetails.STDebtAllocation.sipAmount))}</td>
            )}
        </tr>
    </tbody>
            </table>
           
            <div>
            Or otherwise          
                    <ol>
                        <li> You currently have ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments))} towards Non-Retirement Investments.</li>
                        <li>You need to invest Lumpsum additionally ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.additionalLumsumRqd.value))} towards Non-Retirement Investments</li>
                        <li>Totally you will have to Invest ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) + checkForNullOrNaN(userData.planDetails.additionalLumsumRqd.value))}  towards Non-Retirement Investments</li>
                    </ol>
                    You may rework on your non retirement investments as given below-
                  </div>

{/* table two for investment */}

<table className={styles.actionPlanTable}>
    <thead>
        <tr>
            <th>Fund Type</th>
            <th style={{ textAlign: "right" }}>Allocation</th>
            <th style={{ textAlign: "right" }}>Investment Amount</th>
            
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>Equity Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.equityFunds.allocation)} %
            </td>
            <td style={{ textAlign: "right" }}>
                ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.equityFunds.allocation)*(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) + checkForNullOrNaN(userData.planDetails.additionalLumsumRqd.value))/100)}
            </td>
        </tr>
        <tr>
            <td>Balanced Advantage Hybrid Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.balancedAdvantageHF.allocation)} %
            </td>
            <td style={{ textAlign: "right" }}>
                ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.balancedAdvantageHF.allocation)*(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) + checkForNullOrNaN(userData.planDetails.additionalLumsumRqd.value))/100)}
            </td>
        </tr>
        <tr>
            <td>Conservative Hybrid Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.ConservativeHF.allocation)} %
            </td>
            <td style={{ textAlign: "right" }}>
            ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.ConservativeHF.allocation)*(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) + checkForNullOrNaN(userData.planDetails.additionalLumsumRqd.value))/100)}
            </td>
        </tr>
        <tr>
            <td>Medium Term Debt Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.MTDebtAllocation.allocation)} %
            </td>
            <td style={{ textAlign: "right" }}>
            ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.MTDebtAllocation.allocation)*(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) + checkForNullOrNaN(userData.planDetails.additionalLumsumRqd.value))/100)}
            </td>
        </tr>
        <tr>
            <td>Short Term Debt Funds</td>
            <td style={{ textAlign: "right" }}>
                {checkForNullOrNaN(userData.planDetails.STDebtAllocation.allocation)} %
            </td>
            <td style={{ textAlign: "right" }}>
            ₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.STDebtAllocation.allocation)*(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) + checkForNullOrNaN(userData.planDetails.additionalLumsumRqd.value))/100)}
            </td>
        </tr>
        <tr>
            <td><b>Total :</b></td>
            <td style={{ textAlign: "right" }}>100 %</td>
            <td style={{ textAlign: "right" }}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments) + checkForNullOrNaN(userData.planDetails.additionalLumsumRqd.value))}</td>
        </tr>
    </tbody>
            </table>        
        </>
        )}
        <div className={styles.insuranceDiv}>
            <div>
                <span className={styles.bold}>Insurance</span>
                <span>As per your annual income, below is the recommended insurance cover</span>
            </div>
            <div>
                <span className={styles.bold}>Health Cover</span>
                <span className={styles.bold}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.insurance.hi_si))}</span>
            </div>
            <div><span className={styles.bold}>Life Cover</span> <span className={styles.bold}>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.insurance.li_si))}</span></div>
        </div>
           <div className={styles.apPolicy}><p>Protection is the base of a financial plan. Please ensure you have adequately insured your life, health and are covered against life's unforeseen events. Consult your Relationship Manager for further details.</p></div>
         </div>
         
          {/* Cash Flow */}
          <div className={styles.cashFlow}>
                                   <div className={styles.analysisHead}>
                                        <span><b>Retirement Cash Flow Statement</b></span>
                                    </div>
                                      {/* cash-flow Table */}
                     <div>
                        <table >
                            <thead>
                            <tr>
                                <th>Age (yr)</th>
                                <th style={{textAlign:"right"}}>Beginning Assets</th>
                                <th style={{textAlign:"right"}}>Annual Returns</th>
                                <th style={{textAlign:"right"}}>Annual Savings</th>
                                <th style={{textAlign:"right"}}>Additional Saving</th>
                                <th style={{textAlign:"right"}}>Withdrawal</th>
                                <th style={{textAlign:"right"}}>Year Ending Assets</th>
                            </tr>
                            </thead>
                            <tbody>
                            {rows?.filter((_, index, array) => index % 5 === 0 || index === array.length - 1)
                .map((row, index) => (
                  <tr key={index}>
                    {row.map((cell, i) => (
                      <td key={i} style={{ textAlign: i === 0 ? 'left' : 'right' }}>
                        {i!=0?`₹ ${(cell / 100000).toFixed(2)} Lakhs` :`${cell}`} 
                        {/* typeof cell === "number" ? (cell / 100000).toFixed(2) + ' Lakhs' : */}
                      </td>
                    ))}
                  </tr>
                ))}
                            </tbody>
                        </table>
            
                     </div>
                                   </div>
         {/* Disclaimer */}
         <div className={styles.disclaimer}>
            <div className={styles.discHead}><span>Disclaimer</span></div>
            <p>
            In the preparation of this Retirement Plan ("Plan") and its content including images, text, files, etc., Bajaj Capital Private Limited (BCIAPL) has used information available in public domain including inputs submitted by the client. This plan is  client-specific in nature and is subject to customization doing risk profiling of each client.
            </p>
            <p>

            This plan is developed in-house by BCIAPL in the capacity of a SEBI registered Investment Advisor [SEBI Reg. No. INA100001398]. Information and content related to Insurance product (s) are provided by M/s Bajaj Capital Insurance Broking Limited("BICIBL") a Group Company within the Bajaj Capital Group. BCIBL is an IRDA licensed Composite Broker bearing License No. 241, Broker Code CB 042/02.</p>
            <p>

            The information provided hereinabove is generic in nature, for knowledge and information purposes only. Before taking decision to take out any investment product(s) and/ or insurance policy(ies), you are requested to take appropriate guidance from an investment Advisor/ lnsurance Expert and for tax related matters from a Tax Consultant.</p>
            <p>

            No fees is being charged for preparation of the Plan and the user of the is under no obligation to avail implementation of the Plan from BCIAPL.
            </p>
            <p>
            Mutual Funds Investments are to market risk and read the offer document before investing.
            </p>
            <p>
            Retirement plan is prepared basis assumptions of inflation, expected returns from various investment options for a long term horizon and actual performance may vary from the indicated figures used in plan for illustration purposes.
            </p>
         </div>
    </div>:<div><h1>LOADING...</h1></div> }
            {/* MODAL */}
            { showModal && <Modal setShowModal={setShowModal} flag={downloadFlag} loading={loading} name={userData?.clientsDetails?.client_name} />}

    
    </>
  )
}

export default PlanOutput